import React from 'react'
import '../../index.css'
import { Link } from "react-router";
import { Tooltip } from "react-tooltip";
import missouri from '../../Assets/Img/missouri.jpg'

const Chap21 = () => {
  return (
    <div className="chapter-container">

      <div className="chapterFooter">
          <Link to="/Chap20">Previous</Link>
          <Link to="/">Home</Link>
          <Link to="/Chap22">Next</Link>
      </div>

      <h1 className='chapterHeading'>Chapter 21: Prophesied Events Unfulfilled </h1>

      <img src={missouri} className='image' alt='1831-46 map of the Mormons in Missouri and Illinois' />

    <div className="wrapper">

        <div className='paragraph'>
          <p>Joseph and his followers left the birthplace of Mormonism, New York, and moved to Kirtland, Ohio, on Lake Erie in 1831. On June 6, 1831, the Mormons held a 
            conference in Ohio. At this time, there were 680 Mormons.  
            <btn id="clickable1" className="footnote">1  </btn>
            <Tooltip anchorSelect="#clickable1" className="footnote-size" clickable>2013 Church Almanac, December 12, 2012.</Tooltip>
            
            At the conference, Joseph revealed that “the next conference … shall be held in Missouri, upon the land which I will consecrate unto my people.”
            <btn id="clickable2" className="footnote">2  </btn>
            <Tooltip anchorSelect="#clickable2" className="footnote-size" clickable>D&C 52:2. </Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>From the beginning, Joseph had his eyes on Missouri as the epicenter of his Zion. He later claimed in 1835 that he was shown in “vision” the future site of the 
            holy city. Of this 1831 revelation, Joseph wrote, “I received, by a heavenly vision, a commandment in June [1831], to take my journey to the western boundaries of 
            the State of Missouri, and there designate the very spot which was to be the central place for the commencement of the gathering together of those who embrace the 
            fullness of the everlasting Gospel … the very … [for] the upbuilding of an ‘holy city,’ which should be called Zion.”
            <btn id="clickable3" className="footnote">3  </btn>
            <Tooltip anchorSelect="#clickable3" className="footnote-size" clickable>History of the Church, vol. 2, p. 254; Letter from Joseph to elders of the church; Messenger & Advocate, Sept. 1835, p. 179-180.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>On June 19, 1831, Joseph Smith, Sidney Rigdon, and others started the 900-mile journey to Jackson County. They arrived mid-July at which time it was revealed 
            “the place which is now called Independence is the center place; and a spot for the temple is lying westward, upon a lot which is not far from the courthouse.”
            <btn id="clickable4" className="footnote">4  </btn>
            <Tooltip anchorSelect="#clickable4" className="footnote-size" clickable>D&C 57:3.</Tooltip> 
          </p>
        </div>

        <div className='paragraph'>
          <p>On August 2, 1831, Joseph and others met to discuss building Zion. Joseph recorded, “I assisted … the Church to lay the first log, for a house, as a foundation of 
            Zion ... The log was carried and placed by twelve men in honor of the twelve tribes of Israel. At the same time, through prayer, the land of Zion was consecrated 
            and dedicated by Elder Sidney Rigdon for the gathering of the Saints. It was a season of joy to those present.”  
            <btn id="clickable5" className="footnote">5  </btn>
            <Tooltip anchorSelect="#clickable5" className="footnote-size" clickable>History of the Church vol. 1, p. 196; Book A1, p. 137.</Tooltip> 
            
            The following day, August 3, Joseph dedicated the temple site. Then Joseph returned to Kirtland and the Mormons in Missouri began the work of building up Zion. 
          </p>
        </div>

        <div className='paragraph'>
          <p>In June 1832, Mormon leader in Missouri W.W. Phelps established The Evening and the Morning Star, a monthly newspaper. Excited by their efforts to establish Zion 
            as God had commanded through their prophet, the Mormons began asserting their influence. Independence resident Josiah Gregg recalled “in proportion as 
            [the Mormons] grew strong in numbers, they also became more exacting and bold in their pretensions. In a little paper printed at Independence under their 
            immediate auspices, everything was said that could provoke hostility between ‘saints’ and their ‘worldly’ neighbors, until at last they became so emboldened 
            by impunity, as openly to boast of their determination to be the sole proprietors of the ‘Land of Zion.’”
            <btn id="clickable6" className="footnote">6  </btn>
            <Tooltip anchorSelect="#clickable6" className="footnote-size" clickable>Warren Jennings, Factors in the Destruction of the Mormon Press in Missouri, 1833, Utah Historical Quarterly, Vol. 35, 1967, No. 1.</Tooltip> 
          </p>
        </div>

        <div className='paragraph'>
          <p>The Missourians did not take kindly to talk of the Mormons establishing themselves on sacred Mormon ground and displacing the old-time residents. Joseph’s plan for 
            Zion was no small undertaking. He planned a future city with houses on an organized grid system with 24 Mormon temples at the city center.
            <btn id="clickable7" className="footnote">7  </btn>
            <Tooltip anchorSelect="#clickable7" className="footnote-size" clickable>Stephen Taysom, 2010, “Imagination and Reality in the Mormon Zion,” Shakers, Mormons, and Religious Worlds: Conflicting Visions, Contested Boundaries. Religion in North America. p. 61.</Tooltip> 
          </p>
        </div>

        <div className='paragraph'>
          <p>To make matters worse, the Mormon population increased. In December 1832, approximately 100 Mormons populated Jackson County.  
          <btn id="clickable8" className="footnote">8  </btn>
          <Tooltip anchorSelect="#clickable8" className="footnote-size" clickable>Uncle Dale’s Old Mormon Articles: Early Ohio 1832-34. </Tooltip> 
            
            By 1833, approximately 1,200 Mormons had settled in the county, making up between one-third to one-half of the population.  
            <btn id="clickable9" className="footnote">9  </btn>
            <Tooltip anchorSelect="#clickable9" className="footnote-size" clickable>Cody Newill, The Bloody History of Mormonism in Jackson County, NPR in Kansas City. February 12, 2016.; Steven Harper, Mormon Authority and Identity in America, October 31, 2017, VoegelinView.</Tooltip> 
            
            As the Mormon population increased, tensions emerged on issues of slavery, Mormon collusion with Native Americans, Mormons’ growing political power, and religious 
            issues.  
            <btn id="clickable10" className="footnote">10  </btn>
            <Tooltip anchorSelect="#clickable10" className="footnote-size" clickable>Richard Bushman, 1960. Mormon Persecutions in Missouri, 1833. BYU Studies. 3 (1): 11–20. </Tooltip> 
            
            While things were simmering, relations now reached a boiling point.
          </p>
        </div>

        <div className='paragraph'>
          <p>In July 1833, the Mormons published a newspaper article stating that while the Old Testament “children of Israel” were “compelled to obtain [the Holy Land] by the 
            sword, with the sacrifice of many lives,” land in Jackson County had to be lawfully purchased, writing, “to suppose that we can come up here and take possession of 
            this land by the shedding of blood, would be setting at nought the law of the glorious gospel, and also the word of our great Redeemer: And to suppose that we can 
            take possession of this country, without making regular purchases of the same according to the laws of our nation, would be reproaching this great Republic.”
            <btn id="clickable11" className="footnote">11  </btn>
            <Tooltip anchorSelect="#clickable11" className="footnote-size" clickable>Evening and Morning Star, vol. 2, no. 14.</Tooltip> 
          </p>
        </div>

        <div className='paragraph'>
          <p>Although the article said property rights should be respected, the mention of the land being obtained “by the sword” hearkening back to the Old Testament conquest of the promised land by the Israelites, inflamed Missourians. In response, a mob destroyed the Mormon printing press on July 20, 1833. 
          </p>
        </div>

        <div className='paragraph'>
          <p>Residents of Jackson County met to discuss the problems of the Mormon settlers. A statement was published, accusing Mormons of planning to take over the county. “We are daily told, and not by the ignorant alone, but by all classes of them, that we, (the Gentiles,) of this county are to be cut off, and our lands appropriated by them for inheritances.” If a religious group were to come into your county telling you that your home and land would be given to them by God, how would you react?
          </p>
        </div>

        <div className='paragraph'>
          <p>The Lord, through Joseph, had promised the Mormons everlasting inheritances of property in Jackson County. “… assemble yourselves together to rejoice upon the 
            land of Missouri, which is the land of your inheritance, which is now the land of your enemies.” 
            <btn id="clickable12" className="footnote">12  </btn>
            <Tooltip anchorSelect="#clickable12" className="footnote-size" clickable>D&C 52:42.</Tooltip> 
            
            These everlasting inheritances were homes and lands that the 
            righteous Mormons would inhabit into and through the Millennium.
          </p>
        </div>

        <div className='paragraph'>
          <p>The Missourians’ statement alleged that “many of this deluded and infatuated people have been taught to believe that our lands were to be won from us by the sword.” The statement argued “it requires no gift of prophecy to tell that the day is not far distant when the civil government of the country will be in their hands.”
          </p>
        </div>

        <div className='paragraph'>
          <p>The statement concluded with the demand that no additional Mormons come to the county, that those Mormons present in the county leave, and that the Mormon 
            newspaper cease printing immediately. The statement ended with a threat of violence, calling for “those who fail to comply with these requisitions [to] be 
            referred to those of their brethren who have the gifts of divination ... to inform them of the lot that awaits them.”
            <btn id="clickable13" className="footnote">13  </btn>
            <Tooltip anchorSelect="#clickable13" className="footnote-size" clickable>Uncle Dale’s Old Mormon Articles: Missouri, 1831-1837.</Tooltip>  
          </p>
        </div>

        <div className='paragraph'>
          <p>The demands were presented to the Mormon leaders. According to the Missourians, the Mormons requested an “unreasonable” amount of time to respond. 
            A Missourian mob attacked and burned the newspaper office, destroying the press, tarring and feathering two Mormon leaders, and ordering the Mormon colony to leave 
            the county.  
            <btn id="clickable14" className="footnote">14  </btn>
            <Tooltip anchorSelect="#clickable14" className="footnote-size" clickable>Fawn Brodie, No Man Knows My History, p. 129, 1957.</Tooltip>
            
            There is one person responsible for this disaster: Joseph Smith, who purported to be a prophet. Did he really receive these revelations from God to send innocent people to Missouri, teaching them they were God’s chosen people who, just as the Israelites from the Old Testament, would inhabit the Mormon promised land of Jackson County?
          </p>
        </div>

        <div className='paragraph'>
          <p>On July 23, a mob gathered at the courthouse and rounded up six of the Mormon leaders. They agreed that half of the Mormons would leave the county by January 1, 1834, and the remainder by April 1, 1834. In exchange for leaving, the Missourians would use their influence to prevent violence.
          </p>
        </div>

        <div className='paragraph'>
          <p>In October 1833, W.W. Phelps and Orson Hyde petitioned the Governor for protection and redress for damaged property. The government condemned the violence and advised the Mormons to prosecute their offenders through local courts. To no avail, Mormons filed lawsuits which were denied. Impatient for the January 1 deadline, a mob on October 31 raided a Mormon settlement eight miles west of Independence, damaging several houses and whipping men. The next day, the Mormon storehouse in Independence was sacked, having its goods scattered on the street. On November 4, 50 Missourians gathered near the Big Blue River and captured the Mormon ferry. One Mormon and two non-Mormons were killed. After the local militia intervened, the Mormons surrendered their arms and agreed to leave the county within ten days.
          </p>
        </div>

        <div className='paragraph'>
          <p>By late 1833, the Mormons had been driven out of Jackson County. Again, who is responsible for this? Joseph Smith. If he were a prophet, you would think that the Lord God omnipotent would have a better way to establish his mighty Zion in Jackson County, which prophets had promised for thousands of years.
          </p>
        </div>

        <h2 className="headlinePadding">Zion’s Camp</h2>

        <div className='paragraph'>
          <p>With the troubles in Missouri on his mind, in December 1833, Joseph received a revelation about the “redemption of Zion.”  
          <btn id="clickable15" className="footnote">15  </btn>
          <Tooltip anchorSelect="#clickable15" className="footnote-size" clickable>D&C 101:43.</Tooltip>
            
            Christ revealed that a military solution would be necessary if the Missouri courts did not restore the Mormons to their lands. But when the Missouri courts refused to address the Mormons’ legal complaints, Joseph claimed that Christ revealed it was time for military action. The Lord commanded Joseph to gather the “warriors” of his church and “get ye straightway unto my land; break down the walls of mine enemies; throw down their tower and scatter their watchmen.” In violent language, Christ commanded the Mormons to “avenge me of mine enemies [Missourians], that by and by I may come with the residue of mine house and possess the land.”
          </p>
        </div>

        <div className='paragraph'>
          <p>Christ also revealed that Joseph would lead the Mormons as Moses led the children of Israel, that angels would go before his Mormon warriors, and the presence of 
            God would accompany them. “… the redemption of Zion must needs come by power; Therefore, I will raise up unto my people a man, who shall lead them like as Moses 
            led the children of Israel. For ye are the children of Israel ... Mine angels shall go up before you, and also my presence, and in time ye shall possess the goodly 
            land. Joseph Smith, Jun., is the man … Therefore let my servant Joseph Smith, Jun., say unto the strength of my house, my young men and the middle aged – Gather 
            yourselves together unto the land of Zion.” 
            <btn id="clickable16" className="footnote">16  </btn>
            <Tooltip anchorSelect="#clickable16" className="footnote-size" clickable>D&C 103:15-22.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>After this revelation, Joseph was elected as commander-in-chief of the Armies of Israel by the Kirtland high council. With an all-powerful God commanding these 
            actions, you would believe the Mormons would possess the land. Although there were 4,372 Mormons  
            <btn id="clickable17" className="footnote">17  </btn>
            <Tooltip anchorSelect="#clickable17" className="footnote-size" clickable>2013 Church Almanac, December 12, 2012.</Tooltip>
            
            at this time from which to gather the Lord’s “warriors,” Joseph 
            could only convince 200 men to join his Army. The Mormon military force, with God’s presence going before them, left Kirtland on May 4, 1834. By June 4, they had 
            marched across Indiana and Illinois, reaching the Mississippi River. Entering Missouri, they crossed most of the state by the end of June. However, the Mormons 
            and the Lord God Omnipotent met defeat. Christ’s army was unsuccessful at regaining land from the Missourians. 
          </p>
        </div>

        <div className='paragraph'>
          <p>Receiving word of the approaching Mormons, the Missourians formed militias that outnumbered Zion’s Camp. Upon seeing this, and apparently having little faith in 
            the Lord’s promises, Joseph dictated another revelation stating that the church was presently unworthy to “redeem Zion” because of its lack of commitment to the 
            United Order, or law of consecration.  
            <btn id="clickable18" className="footnote">18  </btn>
            <Tooltip anchorSelect="#clickable18" className="footnote-size" clickable>D&C 105:2-5.</Tooltip>
            
            So blame the members for your prophetic failures. This was typical of Joseph’s treasure digging days. When a treasure was not discovered, Joseph blamed the members of the treasure-digging party for not correctly following his instructions.
          </p>
        </div>

        <div className='paragraph'>
          <p>Joseph told church members they must “wait a little season” to redeem Zion until its elders could receive a promised endowment of heavenly power.  
          <btn id="clickable19" className="footnote">19  </btn>
          <Tooltip anchorSelect="#clickable19" className="footnote-size" clickable>D&C 105:9-13.</Tooltip>
            
            Members of Zion’s camp were disappointed in the failed attempt to redeem Zion. Many wanted to fight and as the Lord revealed to Joseph “avenge me of mine enemies 
            [Missourians], that by and by I may come with the residue of mine house and possess the land.”  
            <btn id="clickable20" className="footnote">20  </btn>
            <Tooltip anchorSelect="#clickable20" className="footnote-size" clickable>D&C 101:58.</Tooltip>
            
            Members of Zion’s Camp criticized Joseph on this matter. To make matters worse for Joseph, before the failed prophet could return to Kirtland, Sylvester Smith 
            rushed back with a dismal story of defeat without honor.
            <btn id="clickable21" className="footnote">21  </btn>
            <Tooltip anchorSelect="#clickable21" className="footnote-size" clickable>Fawn Brodie, No Man Knows My History, p. 159-160, 1945. </Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>Regarding Zion’s Camp, Mormon historian Richard Bushman stated, “Nothing that Joseph aimed to accomplish was achieved. Several hundred men spent three months 
            walking two thousand miles; fourteen of them died. Nothing the camp did improved the situation in Jackson County.”  
            <btn id="clickable22" className="footnote">22  </btn>
            <Tooltip anchorSelect="#clickable22" className="footnote-size" clickable>Richard Bushman, Joseph Smith: Rough Stone Rolling, p. 247.</Tooltip>
            
            Therefore, when Joseph revealed that “angels shall go up before you, and also my presence, and in time ye shall possess the goodly land,”  
            <btn id="clickable23" className="footnote">23  </btn>
            <Tooltip anchorSelect="#clickable23" className="footnote-size" clickable>D&C 103:20.</Tooltip>
            
            was he really speaking for God? But notwithstanding their failure to achieve the promised results of the Lord, Heber Kimball believed heaven had watched over them 
            and that he had seen angels.
            <btn id="clickable24" className="footnote">24  </btn>
            <Tooltip anchorSelect="#clickable24" className="footnote-size" clickable>Matthew Godfrey, “We Believe the Hand of the Lord Is in It”  Memories of Divine Intervention in the Zion's Camp Expedition". BYU Studies Quarterly. 56 (4 2017): 99–132. January 2020..</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>Once the dust had settled in Kirtland, Joseph revealed the Lord’s real reason for Zion’s Camp. It was not about redeeming Zion, as the Lord had stated. Rather, it was about giving a trial to members of the Camp to see who could withstand the heat of the day and become church leaders as Christ would be coming “nigh-even fifty-six years.”
          </p>
        </div>

        <div className='paragraph'>
          <p>According to the official History of the Church, “President Smith then stated … it was made known to him by vision and by the Holy Spirit. He then gave a 
            revelation of some of the circumstances attending us while journeying to Zion ... our trial, sufferings; and said God had not designed all this for nothing, 
            but He had it in remembrance yet; and it was the will of God that those who went to Zion, with a determination to lay down their lives, if necessary, should be 
            ordained to the ministry, and go forth to prune the vineyard for the last time, or the coming of the Lord, which was nigh-even fifty-six years would wind up the 
            scene.”  
            <btn id="clickable25" className="footnote">25  </btn>
            <Tooltip anchorSelect="#clickable25" className="footnote-size" clickable>History of the Church, vol. 2, p. 182.</Tooltip>
            
            Yes, Joseph revealed that 56 years until the winding-up-scene, placing the end of the world in 1890.
          </p>
        </div>

        <div className='paragraph'>
          <p>Therefore, as a reward for the failed mission, upon returning to Kirtland, Joseph organized the Quorum of the Twelve Apostles and the First Quorum of the Seventy, choosing primarily men who had served in Zion’s Camp.
          </p>
        </div>

        </div>

        <div className="chapterFooter">
          <Link to="/Chap20">Previous</Link>
          <Link to="/">Home</Link>
          <Link to="/Chap22">Next</Link>
      </div>
      
    </div>
  )
}

export default Chap21